import styles from './FooterLocalePicker.module.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';

import { LocalePicker } from 'components/SiteFooter/LocalePicker/LocalePicker';

type FooterLocalePickerProps = HTMLAttributes<HTMLDivElement>;

export const FooterLocalePicker: FC<FooterLocalePickerProps> = ({ className, ...props }) => (
  <div className={cx(styles.footerLocalePicker, className)} {...props}>
    <LocalePicker />
  </div>
);

FooterLocalePicker.displayName = 'FooterLocalePicker';
